import { render, staticRenderFns } from "./ContentsForm.vue?vue&type=template&id=33fb9c10&scoped=true"
import script from "./ContentsForm.vue?vue&type=script&lang=js"
export * from "./ContentsForm.vue?vue&type=script&lang=js"
import style0 from "./ContentsForm.vue?vue&type=style&index=0&id=33fb9c10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fb9c10",
  null
  
)

export default component.exports